<template>
    <div class="entry panel-item" >
        <router-link class="list-item-link cell" :to="{ path: `/funnel/${$route.params.id}/steps/${$route.params.step}/product/${product.id}`}">
            <div class="products_panel_first_cell cell">
                <div class="products_panel_square_label">
                    <img :src="require('@/assets/img/ob_label.svg')" alt="">
                </div>
            </div>
            <div class="panel-item-cell cell">
                <div class="product_panel_link">{{product.attributes.name}}</div>
                <span class="result-tag">
                    {{product.attributes['is-subscription'] ? 'Subscription' : 'One-time'}}
                </span>
            </div>
            <div class="panel-item-cell product-price-cell cell" v-if="product.attributes['is-subscription']">
                <h3 class="price">{{currencySymbol+' '+product.attributes['billing-amount']}}</h3>
                <span class="products_panel_weeks">
                    {{product.attributes['billing-cycle']}}
                    {{ getCycleType(product.attributes['cycle-type']) }}
                </span>
            </div>
            <div class="panel-item-cell product-price-cell cell" v-else>
                <h3 class="price">{{currencySymbol+' '+product.attributes.price}}</h3>
            </div>
        </router-link>
        <div class="panel_item_btn_wrpr cell">
            <a @click.prevent="showCloneProductPopup(product)" class="panel_item_btn copy_btn">
                <inline-svg :src="require('@/assets/img/copy_icon.svg')"/>
            </a>
            <a @click.prevent="showProductDeletePopup(product.id)" class="panel_item_btn delete_btn">
                <inline-svg :src="require('@/assets/img/delete_icon.svg')"/>
            </a>
        </div>
    </div>
</template>

<script >
    import API from "@/api";
    import {getSymbol} from "@/helpers/currencies";
    import {mapGetters} from "vuex";

    export default {
        name: "ProductEntry",
        props: ["product", "noactions"],
        mixins: [API],

        data() {
            return {
                productId: 0,
                productClone: {},
                closed: false,
            }
        },
        computed: {
            ...mapGetters([
                "getProductsStore",
                "getFunnelStore",
            ]),
            currencySymbol() {
                let symbol;
                if(this.getFunnelStore.currency_code !== "") {
                    symbol = getSymbol(this.getFunnelStore.currency_code);
                } else {
                    symbol = '$';
                }
                return symbol
            },

        },
        methods: {
            getCycleType(type) {
                let string = '';
                switch (type) {
                    case 1:
                        string = ' day(s)';
                        break;
                    case 2:
                        string = ' week(s)';
                        break;
                    case 3:
                        string = ' month(s)';
                        break;
                    case 4:
                        string = ' year(s)';
                        break;
                }
                return string
            },
            showProductDeletePopup(thisProductId) {
                this.productId = thisProductId;
                this.$store.commit("showProductDeletePopup");
            },
            showCloneProductPopup(item) {
                this.productClone = item;
                this.$store.commit("showCloneProductPopup");
            },
        },
    };
</script>

<style lang="scss" scoped>
    .funnel-entry {

    }
</style>
